// extracted by mini-css-extract-plugin
module.exports = {"modalBtn":"styles_modalBtn__J65TR","file":"styles_file__1TVlx"};